// extracted by mini-css-extract-plugin
export default {"container":"INjos","backBtn":"UsoRN","image":"yKWro"};